import { useDispatch, useSelector } from "react-redux";

import moment from "moment";

import { getConsultationStatistics } from "../../../../../redux/actions/reportActions";
import { REPORT_FILTER_ACTION_TYPE } from "../../../../../redux/actions-type";
import { useEffect, useState } from "react";

export const useReportSalesCustomHook = () => {
  const dispatch = useDispatch();
  const { courseId, whereComingId } = useSelector(
    (state) => state.studentStatus
  );

  const [date, setDate] = useState({});

  const start = moment(date.startDate).format("YYYY-MM-DD");
  const end = moment(date.endDate).format("YYYY-MM-DD");

  const {
    consultationStatisticChooseDate,
    consultationStatisticMonthFilter,
    selectedDateType,
    consultationStatisticSelectedOption,
  } = useSelector((state) => state.reportDateFilter);




  const getAllDefaultData = () => {
    dispatch(getConsultationStatistics("", "", 1, "", "", selectedDateType.key));
  };

  useEffect(() => {
    getAllDefaultData();
  }, []);

  const getAllDataByMonth = (monthCount) => {
    dispatch(
      getConsultationStatistics(
        "",
        "",
        monthCount,
        courseId,
        whereComingId,
        selectedDateType.key
      )
    );
    setDate({});
  };

  const getAllDataByDateRange = (startDate, endDate) => {
    dispatch(
      getConsultationStatistics(
        start,
        end,
        "",
        courseId,
        whereComingId,
        selectedDateType.key
      )
    );
  };

  const getFinanceDataAfterUpdate = () => {
    if (
      consultationStatisticChooseDate.startDate &&
      consultationStatisticChooseDate.endDate
    ) {
      const start = moment(consultationStatisticChooseDate.startDate).format(
        "YYYY-MM"
      );
      const end = moment(consultationStatisticChooseDate.endDate).format(
        "YYYY-MM"
      );
      dispatch(
        getConsultationStatistics(start, end, "", courseId, whereComingId,selectedDateType.key)
      );
    } else {
      dispatch(
        getConsultationStatistics(
          "",
          "",
          consultationStatisticMonthFilter || 1,
          courseId,
          whereComingId,
          selectedDateType.key
        )
      );
    }
  };

  const getFinanceDataAfterCreate = () => {
    dispatch({
      type: REPORT_FILTER_ACTION_TYPE.GET_CONSULTATION_STATISTICS_MONTH_FILTER,
      payload: { reportMonthFilter: "" },
    });
    dispatch({
      type: REPORT_FILTER_ACTION_TYPE.GET_CONSULTATION_STATISTICS_DATE_SELECTED_OPTION,
      payload: {
        key: 1,
        name: "Cari ay",
      },
    });
    dispatch(getConsultationStatistics("", "", 1, "", "", selectedDateType));
  };

  const selectDateTypeOption = (type) => {
    dispatch({
      type: REPORT_FILTER_ACTION_TYPE.GET_SELECTED_DATE_TYPE,
      payload: type,
    });

    dispatch(
      getConsultationStatistics(
        consultationStatisticSelectedOption.key ? "" : start,
        consultationStatisticSelectedOption.key ? "" : end,
        consultationStatisticMonthFilter || 1,
        courseId,
        whereComingId,
        type.key
      )
    );
  };

  return {
    getAllDefaultData,
    getAllDataByMonth,
    getAllDataByDateRange,
    getFinanceDataAfterCreate,
    getFinanceDataAfterUpdate,
    selectDateTypeOption,
    date,
    setDate,
  };
};
